import { useQuery } from "@tanstack/vue-query";
import { useRouteParams } from "@vueuse/router";
import { useContentCommandApi } from "@/composables/useContentCommandApi";

export function useCurrentExperienceOptionNamesQuery() {
  const experienceId = useRouteParams("id", "");

  const query = useExperienceOptionNamesQuery(experienceId);

  return query;
}

export function useExperienceOptionNamesQuery(experienceId: Ref<string>) {
  const { getExperienceOptionNames } = useContentCommandApi();

  const query = useQuery({
    queryKey: ["experience-option-names", experienceId.value],
    queryFn: () => getExperienceOptionNames(experienceId.value),
    enabled: computed(() => !!experienceId.value),
    select: (response) => response.data,
  });

  return query;
}
